import React from "react";
import PDFPage from "pdfs/PDFPage";

export default function MonthlyReportOutro(props) {
  return (
    <PDFPage pageNumber={props.pageNumber} hideLogo={props.white_label_service}>
      <div style={{ textAlign: "center", marginTop: "30%" }}>
        <h3>Any questions about your monthly report? Ask your account leads.</h3>
        <h4 style={{ marginTop: "5%" }}>More detailed data can be found by logging into DataPulse</h4>
        <ul>
          <li>Campaign groups</li>
          <li>Spend allocation</li>
          <li>& more!</li>
        </ul>
      </div>
    </PDFPage>
  );
}
